import type { Color } from 'src/types/theme';

import { comparison } from './comparison';
import { error } from './error';
import { green } from './green';
import { info } from './info';
import { neutral } from './neutral';
import { primary } from './primary';
import { red } from './red';
import { secondary } from './secondary';
import { success } from './success';
import { tertiary } from './tertiary';
import { violet } from './violet';
import { warning } from './warning';
import { yellow } from './yellow';

export interface ColorPalettes {
  primary: Color;
  secondary: Color;
  tertiary: Color;
  comparison: Color;
  error: Color;
  green: Color;
  info: Color;
  neutral: Color;
  red: Color;
  success: Color;
  violet: Color;
  warning: Color;
  yellow: Color;
}

export const colorPalettes: ColorPalettes = {
  primary,
  secondary,
  tertiary,
  comparison,
  error,
  green,
  info,
  neutral,
  red,
  success,
  violet,
  warning,
  yellow,
};
